import React, {useState} from 'react'
import "./editor.css";

function BlogEditor({content, setContent}) {
    const [textContent, setTextContent] = useState('');

    const updateContent = (e) => {
        const text = e.target.value;
        setTextContent(text);
        // Convert plain text to a simple format that the parent expects
        setContent(text);
    };

    return (
        <div className="editor-container">
            <textarea
                className="blog-editor"
                value={textContent}
                onChange={updateContent}
                placeholder="Write your blog content here..."
                rows={20}
                style={{
                    width: '100%',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    padding: '12px',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical'
                }}
            />
        </div>
    );
}

export default BlogEditor